import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { injectIntl, FormattedMessage } from 'react-intl';
import IconSvg from '../../common/IconSvg';
import { themeColors } from '../../../constants/themes';

const Container = styled.div`
  text-align: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  color: ${themeColors.blue};
  height: 100%;
  border: 1px dashed ${themeColors.dirtyLightBlue};
  border-radius: 4px;
  padding: 0.5em;
  min-height: 173px;
  ${({ isJA }) => isJA && 'font-size: 10px;'}
  &:not(:last-child) {
    margin-bottom: 1em;
  }
`;

@injectIntl
class ActionCard extends Component {
  render() {
    const { intlId, clickHandler, iconType, isJA } = this.props;
    return (
      <Container onClick={clickHandler} isJA={isJA}>
        <IconSvg size={22} type={iconType} />
        <FormattedMessage id={intlId} />
      </Container>
    );
  }
}

ActionCard.propTypes = {
  intlId: PropTypes.string,
  clickHandler: PropTypes.func,
  iconType: PropTypes.string,
  isJA: PropTypes.bool,
};

export default ActionCard;
